import { createResource, createRoot } from "solid-js";
import { getMeteringBalance } from "@/client";
import type { MeteringCustomerBalanceResponse } from "@/client/types.gen";

async function fetchMeteringBalance(): Promise<
	MeteringCustomerBalanceResponse | undefined
> {
	const response = await getMeteringBalance();
	return response.data;
}

function createMeteringBalance() {
	const [balance, { refetch }] = createResource(fetchMeteringBalance);
	return { balance, refetch };
}

let shared: ReturnType<typeof createMeteringBalance> | undefined;

/** Shared across every caller on the page, so remounts and siblings reuse one fetch. */
export function useMeteringBalance() {
	if (!shared) {
		shared = createRoot(() => createMeteringBalance());
	}
	return shared;
}

/**
 * Whether the viewer's balance has loaded with no credits left. A balance that
 * hasn't loaded, or failed to, is not counted: the server fails open then too.
 */
export function hasNoCreditsLeft(): boolean {
	const { balance } = useMeteringBalance();
	if (balance.state !== "ready") {
		return false;
	}
	const available = balance()?.credits?.available;
	return typeof available === "number" && available <= 0;
}
